import React, { useState } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Mouse, AspectRatio, ScreenshotMonitor } from '@mui/icons-material/';

const style = { //Estilos para el contenedor del mensaje.
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'var(--bg-border-by-mode)',
    border: '2px solid var(--bg-border-by-mode)',
    color: 'var(--bg-text-inbox-by-mode)',
    boxShadow: 24,
    p: 4,
};

const instruccionStyle = { //Estilo para el contenedor de la instrucción individual
    mt: 4,
    borderRadius: "20px",
    p: 2,
    bgcolor: "var(--bg-hover-by-mode)"
}

const textBoldStyle = { //Estilo para los textos en negritas
    fontWeight: 'bold',
    marginLeft: "5px",
    marginRight: "5px"
}

// ModalMessageResolutions: Componente que renderiza el mensaje de recordatorio de ajuste de resoluciones de la pantalla inicial.

const ModalMessageResolutions = () => {
    const [open, setOpen] = useState(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h5" component="h2" fontFamily="Poppins" fontWeight="600" display="flex" alignItems="center">
                        <span><ScreenshotMonitor sx={{ marginLeft: "5px", marginRight: "10px", fontSize: "30px" }} /></span> 
                         Ajuste de resolución
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} fontFamily="Poppins" textAlign="center">
                        Para mejorar la experiencia, ajuste la <strong>resolución del navegador </strong>
                        hasta llegar a las disposiciones correctas.
                    </Typography>
                    <Typography id="modal-modal-description" sx={instruccionStyle} fontFamily="Poppins" justifyContent="center" display="flex">
                        Presione
                        <Typography component="span" variant="inherit" sx={textBoldStyle}>
                            F11
                        </Typography>
                        <span><AspectRatio sx={{ marginLeft: "5px", marginRight: "5px" }} /></span> para
                        <Typography component="span" variant="inherit" sx={textBoldStyle}>
                            Pantalla Completa
                        </Typography>
                    </Typography>
                    <Typography id="modal-modal-description" sx={instruccionStyle} fontFamily="Poppins" justifyContent="center" display="flex">
                        Presione
                        <Typography component="span" variant="inherit" sx={textBoldStyle}>
                            Ctrl
                        </Typography>
                        + <span><Mouse /></span>
                        <Typography component="span" variant="inherit" sx={textBoldStyle}>
                            la rueda de desplazamiento del ratón
                        </Typography>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} fontFamily="Poppins" textAlign="center">
                        Hacia delante o atrás, hasta lograr una relación de zoom del
                        <Typography component="span" variant="inherit" sx={textBoldStyle}>
                            70%, 90%
                        </Typography>
                        o
                        <Typography component="span" variant="inherit" sx={textBoldStyle}>
                            100%
                        </Typography>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} fontFamily="Poppins" justifyContent="center" display="flex">
                        <button className="btn-submit-info" onClick={handleClose}>Entendido</button>
                    </Typography>
                </Box>
            </Modal>
        </div>
    )
};

export default ModalMessageResolutions;